var map = {
	"./en": [
		"ls7f"
	],
	"./en.json": [
		"ls7f"
	],
	"./it": [
		"7rMW",
		5
	],
	"./it.json": [
		"7rMW",
		5
	],
	"./ru": [
		"qmXk",
		6
	],
	"./ru.json": [
		"qmXk",
		6
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "npnW";
module.exports = webpackAsyncContext;